module.exports = __webpack_public_path__ + "static/mimic-c12251b5c80fd038522b0bd614bc177b.png";